import cn from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

type Item = {
  id: string;
  name: string;
  href: string;
  external: boolean;
  items?: Array<Item>;
};

type Props = {
  title: string;
  items?: Array<Item>;
  isExtraPage?: boolean;
};

export default function ListLink({ title, items, isExtraPage }: Props) {
  const { locale } = useRouter();
  return (
    <div
      className={cn('desktop:space-y-6 space-y-4 pr-2', {
        'desktop:col-span-2': isExtraPage,
      })}
    >
      <h3 className="text-body16 text-neutral-90 desktop:text-subtitle20 text-left font-bold">
        {title}
      </h3>
      <ul className="text-body14 text-neutral-90 desktop:space-y-4 desktop:text-body16 space-y-3 text-left">
        {items?.map((item, idx) =>
          item.items ? (
            <div
              key={idx}
              className={cn(
                'desktop:space-y-6 desktop:!mt-6 !mt-4 space-y-4 pr-2',
                {
                  'desktop:col-span-2': isExtraPage,
                }
              )}
            >
              <h3 className="text-body16 text-neutral-90 desktop:text-subtitle20 text-left font-bold">
                {item.name}
              </h3>
              <ul className="text-body14 text-neutral-90 desktop:space-y-4 desktop:text-body16 space-y-3 text-left">
                {item.items?.map((subItem, subIdx) => (
                  <li key={subIdx}>
                    <Link
                      href={subItem.href}
                      rel="noreferrer"
                      passHref
                      locale={locale}
                      title={subItem.name}
                      className="hover:text-neutral-70"
                      target={subItem.external ? '_blank' : '_self'}
                    >
                      {subItem.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <li key={idx}>
              <Link
                href={item.href}
                rel="noreferrer"
                passHref
                locale={locale}
                title={item.name}
                className="hover:text-neutral-70"
                target={item.external ? '_blank' : '_self'}
              >
                {item.name}
              </Link>
            </li>
          )
        )}
      </ul>
    </div>
  );
}
